import { ILiteral } from "../services/LiteralesServices.dto";

export const getText = (literales: ILiteral[], key: string, defaultValue = ""): string => {
  const textObject = literales.find((literal) => literal.key === key);
  return textObject ? textObject.literal_ES : defaultValue;
};
